import React, { useRef, useState,useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { clearAll } from 'src/redux/registrant';
import Form from 'components/Form/Form';
import vw from 'src/styles/utils';
import media from 'src/styles/media';
import Helmet from 'react-helmet';
import Input from 'components/Form/elements/Input';
import Select from 'components/Form/elements/Select';
import SelectList from 'src/components/SelectList';
import SelectPlan from './elements/SelectPlan';
import SelectView from './elements/SelectView';
import SelectPrice from './elements/SelectPrice';
import CountrySelector from 'components/Form/elements/CountrySelector';
import Button from 'components/Button';
import Checkbox from 'components/Form/elements/Checkbox';
import { getSearchUser } from 'src/scripts/requests';
import questionSelections from 'src/data/questionSelections';


import homeOptions from 'src/data/homeOptions';
import floorplansData from 'src/data/floorplans';

const HomeSelectionForm = () => {
  const { person, email,BCFS,HSFStart } = useSelector((state) => state.registrant);
  const [isLoading, setIsLoading] = useState(false);
  const [isWorkingWithRealtor, setIsWorkingWithRealtor] = useState(null);
  const [showNumberBuyerSection, setshowNumberBuyerSection] = useState(1);
  const [homeOptionOneDisable, setHomeOptionOneDisable] = useState([false, true, true, true]);
  const [homeOptionFloorplans1, setHomeOptionFloorplans1] = useState(null);
  const [homeOptionTwoDisable, setHomeOptionTwoDisable] = useState([false, true, true, true]);
  const [homeOptionFloorplans2, setHomeOptionFloorplans2] = useState(null);
  const [homeOptionThreeDisable, setHomeOptionThreeDisable] = useState([false, true, true, true]);
  const [homeOptionFloorplans3, setHomeOptionFloorplans3] = useState(null);
  const buyerNumberSelectRef = useRef(null);
  const [confirmContactEmailInputDisabled, setConfirmContactEmailInputDisabled] = useState(true);
  const [confirmContactInputSetDisabled, setconfirmContactInputSetDisabled] = useState(true);
  const [isNewContact, setIsNewContact] = useState(true);
  const [confirmCRealtorEmailInputDisabled, setConfirmCRealtorEmailInputDisabled] = useState(true);
  const [isNewRealtor, setIsNewRealtor] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    // if(!HSFStart){
    //  window.location.replace("/vhome-selection-start");
    // }
    window.scrollTo(0, 0)
    // getQueryVariable("id")
     // if(!){
     //   if(!submitting){
     //     console.log("NO ID")
     //     //window.location.replace("/email/");
     //   }
     // }


   }, [])

  const handleSelectIsWorkingWithRealtor = (e) => {
    setIsWorkingWithRealtor(e.target.selectedIndex);
    console.log(e.target.selectedIndex)
    if(e.target.selectedIndex === 1){
      setConfirmCRealtorEmailInputDisabled(true)
    }
  }


  const emailLookUpField = document.getElementById('confirmEmail')
  //emailLookUpField

  const timer = null;
  const handleKeyDown = (e) =>{
    // clearTimeout(timer);
    // timer = setTimeout(
    //   handleEmailLookUp
    // , 1000)
  }

  const handleEnableConfirmEmail = (email) =>{
    const emailInput = document.querySelector("#contactEmail");
    if(emailValidation(emailInput.value)){
      setConfirmContactEmailInputDisabled(false)
    }else{
      alert("Please enter a valid email address")
    }
  }

  let foundContact = {};


  const handleContactEmailLookUp = async (e) =>{

    const emailInput1 = document.querySelector("#contactEmail");
    const emailInput2 = document.querySelector("#confirmEmail");

    console.log(emailValidation(emailInput2.value))

    if(emailInput1.value === emailInput2.value){
      setIsLoading(true)
      foundContact = await getSearchUser(emailInput2.value)
      setIsLoading(false)
      setconfirmContactInputSetDisabled(false)

      console.log(foundContact)
      if(foundContact.length > 0){
        document.querySelector("#contactFirstName").value = foundContact[0].first_name;
        document.querySelector("#contactLastName").value = foundContact[0].last_name;
        document.querySelector("#contactPhone").value = foundContact[0].phone;
        document.querySelector("#contactID").value = foundContact[0].id;

        setConfirmContactEmailInputDisabled(true)
        setIsNewContact(false)
      }else{

        alert("Record not found. Please enter your first name, last name and phone number.")
      }


    }else{
      if(emailInput2.value != "") {
      alert("Buyer email address do not match")
      }
    }


  }

  let foundRealtor = {};

  const handleRealtorEmailLookUp = async (e) =>{
    const emailInput = document.querySelector("#realtorEmail");
    if(emailInput.value != "") {

    if(emailValidation(emailInput.value)){
      setIsLoading(true)
      foundRealtor = await getSearchUser(emailInput.value)
      setIsLoading(false)
      setConfirmCRealtorEmailInputDisabled(false)
      //console.log(foundRealtor[0].agent)
      if(foundRealtor.length > 0 && foundRealtor[0].agent){
        emailInput.disabled = true;
        document.querySelector("#realtorID").value = foundRealtor[0].id;
        document.querySelector("#realtorFirstName").value = foundRealtor[0].first_name;
        document.querySelector("#realtorLastName").value = foundRealtor[0].last_name;
        document.querySelector("#realtorBrokerage").value = foundRealtor[0].brokerage_name;
        setConfirmCRealtorEmailInputDisabled(false)
        setIsNewRealtor(false)
      }else{

        alert("Please enter your Realtor's first name, last name and brokerage")
      }
    }else{
      alert("Please enter a valid email address")
    }
  }
  }

  const emailValidation = (email) =>{
    console.log(email)
    if(email != ""){
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
      email
    )
  }return true
    // if (
    //   //eslint-disable-next-line
    //   !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
    //     email
    //   )
    // ) {
    //   missing += '- Realtor email is invalid\r\n';
    //   // missing += ' ';
    // }

  }


  const handleFormSubmit = async (e) => {
    e.preventDefault();
   setIsLoading(true)
    const forms = document.querySelectorAll('form');
    const form = forms[0];
    let error = 0;

    var customRequired = document.querySelectorAll(
      'input:required, textarea:required, select:required, checkbox:required'
    );

    for (var i = 0; i < customRequired.length; i++) {
      // required[customRequired[i].id] = customRequired[
      //   i
      // ].parentNode.firstElementChild.innerHTML.replace('*', '');
      //console.log(document.getElementById(customRequired[i].id).parentNode.classList.add("error"))

      if(document.getElementById(customRequired[i].id).type === "checkbox" && !document.getElementById(customRequired[i].id).checked || document.getElementById(customRequired[i].id).value === "" || document.getElementById(customRequired[i].id).value === "--"){
        document.getElementById(customRequired[i].id).parentNode.classList.add("error");
        error += 1;
      }else{
        document.getElementById(customRequired[i].id).parentNode.classList.remove("error");
      }



      //console.log(document.getElementById(customRequired[i].id).type)




      //console.log(document.getElementById(customRequired[i].id));
      //document.getElementById(customRequired[i].id).previousSibling.style.color = "#FC0";
     // error = error + 1;
    }





    const fileInput1 = document.querySelector("#id_frontside_image");
    const fileInput2 = document.querySelector("#residencyStatusPhotoId");
    const formData = new FormData();

    formData.append("id_frontside_image", fileInput1.files[0]);
    formData.append("residencyStatusPhotoId", fileInput2.files[0]);

    Array.from(form.elements).forEach((input) => {
      if (input.type !== "file") {
        //console.log(input.type + ": " +input.name + "====" + input.value);

        formData.append(input.name, input.value);
      }

    });

    console.log("ERROR Counts:" + error)


    if(error === 0){
      const response = await fetch('https://hook.integromat.com/avfy7unxqtcavxz94feo806j7odt3add', {
      method: "POST",
      body: formData
    });
     const responseJson = await response.json();
     if(responseJson.status === "success"){
      window.location.replace("/additional-buyer-complete");
     }

    }else{
      alert("Please fill all required* fields")
    }
    setIsLoading(false)


    //const registrantData = await HomeRequestSubmission(email);
  }


  const handleChangeNumberOfBuyers = (e) => {
    console.log(e.target.value)

    switch (e.target.value) {
      case '2':
        setshowNumberBuyerSection(2);
        break;
      case '3':
        setshowNumberBuyerSection(3);
        break;
      case '4':
        setshowNumberBuyerSection(4);
        break;
      default:
        setshowNumberBuyerSection(1);
        break;
    }
  }

  const handleChangeHomeOptionOneBeds = (e) => {
    document.getElementById('homeOptionOnePlan').value = '--';
    document.getElementById('homeOptionOneView').value = '--';
    document.getElementById('homeOptionOnePrice').value = '--';
    setHomeOptionOneDisable([false, false, true, true]);
    setHomeOptionFloorplans1(floorplansData.filter(floorplan => floorplan.type===e.target.value));
  }

  const handleChangeHomeOptionOnePlan = () => {
    document.getElementById('homeOptionOneView').value = '--';
    document.getElementById('homeOptionOnePrice').value = '--';
    setHomeOptionOneDisable([false, false, false, true]);
  }

  const handleChangeHomeOptionOneView = () => {
    document.getElementById('homeOptionOnePrice').value = '--';
    setHomeOptionOneDisable([false, false, false, false]);
  }

  //
  const handleChangeHomeOptionTwoBeds = (e) => {
    document.getElementById('homeOptionTwoPlan').value = '--';
    document.getElementById('homeOptionTwoView').value = '--';
    document.getElementById('homeOptionTwoPrice').value = '--';
    setHomeOptionTwoDisable([false, false, true, true]);
    setHomeOptionFloorplans2(floorplansData.filter(floorplan => floorplan.type===e.target.value));
  }

  const handleChangeHomeOptionTwoPlan = () => {
    document.getElementById('homeOptionTwoView').value = '--';
    document.getElementById('homeOptionTwoPrice').value = '--';
    setHomeOptionTwoDisable([false, false, false, true]);
  }

  const handleChangeHomeOptionTwoView = () => {
    document.getElementById('homeOptionTwoPrice').value = '--';
    setHomeOptionTwoDisable([false, false, false, false]);
  }

  //
  const handleChangeHomeOptionThreeBeds = (e) => {
    document.getElementById('homeOptionThreePlan').value = '--';
    document.getElementById('homeOptionThreeView').value = '--';
    document.getElementById('homeOptionThreePrice').value = '--';
    setHomeOptionThreeDisable([false, false, true, true]);
    setHomeOptionFloorplans3(floorplansData.filter(floorplan => floorplan.type===e.target.value));
  }

  const handleChangeHomeOptionThreePlan = () => {
    document.getElementById('homeOptionThreeView').value = '--';
    document.getElementById('homeOptionThreePrice').value = '--';
    setHomeOptionThreeDisable([false, false, false, true]);
  }

  const handleChangeHomeOptionThreeView = () => {
    document.getElementById('homeOptionThreePrice').value = '--';
    setHomeOptionThreeDisable([false, false, false, false]);
  }

  return (
    <Root>
      <Loading active={isLoading} />
      <Helmet meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }
      ]}
      />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />


      <h1>Additional Purchaser Information Required</h1>
      {/* <h3>DUE: Wednesday, February 23rd, 2022 at 11:59PM.</h3> */}
      <p>You have been named as an Additional Purchaser in a Home Selection Form for RC at CF Richmond Centre, please provide the following information.</p>
      {/* <input type="hidden" name="isNewContact" value={isNewContact} />
      <input type="hidden" name="isNewRealtor" value={isNewRealtor} /> */}
      <input type="hidden" name="contactID" id="contactID"   />
      {/* <input type="hidden" name="realtorID" id="realtorID"   />
      <input type="hidden" name="BCFS" id="BCFS" value={BCFS}  />
      <input type="hidden" name="answers[8454][answers]" id="answers[8454][answers]" value={BCFS ? 'No':'Yes'}  /> */}


      <br /><br /><br />
      <FormSection>
        <Fields>
          <Input
            label="Additional Buyer's Email Address*"
            id="contactEmail"
            class="block"
            required
            handleonBlur={(e) => handleEnableConfirmEmail(e)}
            disabled = {!isNewContact}
          />
          <Input
            label="Confirm Additional Buyer's Email Address*"
            id="confirmEmail"
            class="block"
            handleonBlur={(e) => handleContactEmailLookUp(e)}
            disabled = {confirmContactEmailInputDisabled}
            required
          />

          <div className="singleRow">
            <Checkbox
              label="I confirm this email belongs to me, the additional buyer. I understand that this email address cannot represent more than one buyer on the contract.*"
              id="answers[3040][answers]"
              key="Consent Required"
              required
            />
          </div>
          <Input
            label="First Name*"
            id="contactFirstName"
            class="block"
            hidden={confirmContactInputSetDisabled}
            required={!confirmContactInputSetDisabled}
          />
          <Input
            label="Last Name*"
            id="contactLastName"
            class="block"
            hidden={confirmContactInputSetDisabled}
            required={!confirmContactInputSetDisabled}
          />
          <Input
            label="Phone Number*"
            id="contactPhone"
            class="block"
            placeholder="e.g. 555-555-5555 or +555 5555 5555"
            hidden={confirmContactInputSetDisabled}
            required={!confirmContactInputSetDisabled}
          />
        </Fields>
        </FormSection>
      <FormSection>
        <h3>BUYER INFORMATION</h3>
        <Fields>
          <div>
            <p>To confirm your identity, please upload a copy of your Driver’s Licence or BC ID Card.</p>

            <p>Other forms of ID are accepted if it meets the following criteria:</p>
            <ul>
              <li>Contains a photo</li>
              <li>Is government issued</li>
              <li>Includes your legal name</li>
              <li>Includes your registered mailing address</li>
              <li>Valid (not expired)</li>
            </ul>
            <p>The image must be high quality, unobstructed and uncropped.</p>
            <br />
            <br />
          </div>

          <Input
            label="Buyer Information*"
            id="id_frontside_image"
            type="file"
            accept="image/jpeg,image/png"
            required
          />

          <Input
            label="Legal Given Name(s) (First and Middle)*"
            id="buyerGivenName"
            placeholder="Given name(s) as it appears on Photo ID"
            required
          />
          <Input
            label="Legal Surname (Last name)*"
            id="buyerSurname"
            placeholder="Surname as it appears on Photo ID"
            required
          />
          <Input
            label="Address Line 1*"
            id="buyerAddress1"
            placeholder="Street address"
            required
          />
          <Input
            label="Address Line 2 (Optional)"
            id="buyerAddress2"
            placeholder="Apartment, suite, unit, building, p.o. box, etc."

          />
          <Input
            label="City*"
            id="buyerCity"
            placeholder=""
            required
          />
          <Input
            label="Province/State*"
            id="buyerProvince"
            placeholder=""
            required
          />
          <CountrySelector
          />
          <Input
            label="Postal/Zip Code*"
            id="buyerPostalCode"
            placeholder=""
            required
          />
          <Input
            label="Date of Birth"
            id="buyerBirthday"
            placeholder="e.g. YYYY-MM-DD"
            type="date"

          />
          {/* <div></div>
          <Select
            label="Reason For Purchase*"
            question={questionSelections.reasonForPurchase}
            required
          />
          <Select
            label="Number Of Homes Requested*"
            question={questionSelections.numberOfHomesRequested}
            required
          />
          <Select
            label="Number Of Buyers On Contract*. You must identify how many additional buyers there will be on the contract along with their correct contact information. If this information is inaccurate or incorrect, you may be denied a home allocation."
            question={questionSelections.numberOfBuyers}
            ref={buyerNumberSelectRef}
            onChange={handleChangeNumberOfBuyers}
            required
          />
          <Select
            label="Colour Scheme"
            question={questionSelections.colourScheme}

          /> */}
        </Fields>
      </FormSection>

      {/* <FormSection hide={showNumberBuyerSection < 2}>
        <h3>BUYER TWO</h3>
        <p>Please ensure you are providing accurate information for each buyer to be named on the contract</p>
        <Fields>
          <Input
            label="First Name*"
            id="buyerTwoFirstName"
            placeholder=""
            required={showNumberBuyerSection < 2 ? false : true}
          />
          <Input
            label="Last Name*"
            id="buyerTwoLastName"
            placeholder=""
            required={showNumberBuyerSection < 2 ? false : true}
          />
          <Input
            label="Email*"
            id="buyerTwoEmail"
            placeholder=""
            required={showNumberBuyerSection < 2 ? false : true}
          />
          <Input
            label="Phone*"
            id="buyerTwoPhone"
            placeholder="e.g. 555-555-5555 or +555 5555 5555"
            required={showNumberBuyerSection < 2 ? false : true}
          />
          <div className="singleRow">
            <Checkbox
              label="I confirm this email belongs to buyer two. I understand that this email address cannot represent more than one buyer on the contract.*"
              id="buyerTwoConsent"
              key="Buyer Two - Consent Required"
              required={showNumberBuyerSection < 3 ? false : true}
            />
          </div>
        </Fields>
      </FormSection>

      <FormSection hide={showNumberBuyerSection < 3}>
        <h3>BUYER THREE</h3>
        <p>Please ensure you are providing accurate information for each buyer to be named on the contract</p>
        <Fields>
          <Input
            label="First Name*"
            id="buyerThreeFirstName"
            placeholder=""
            required={showNumberBuyerSection < 3 ? false : true}
          />
          <Input
            label="Last Name*"
            id="buyerThreeLastName"
            placeholder=""
            required={showNumberBuyerSection < 3 ? false : true}
          />
          <Input
            label="Email*"
            id="buyerThreeEmail"
            placeholder=""
            required={showNumberBuyerSection < 3 ? false : true}
          />
          <Input
            label="Phone*"
            id="buyerThreePhone"
            placeholder="e.g. 555-555-5555 or +555 5555 5555"
            required={showNumberBuyerSection < 3 ? false : true}
          />
          <div className="singleRow">
            <Checkbox
              label="I confirm this email belongs to buyer three. I understand that this email address cannot represent more than one buyer on the contract.*"
              id="buyerThreeConsent"
              key="Buyer Three - Consent Required"
              required={showNumberBuyerSection < 3 ? false : true}
            />
          </div>
        </Fields>
      </FormSection>

      <FormSection hide={showNumberBuyerSection < 4}>
        <h3>BUYER FOUR</h3>
        <p>Please ensure you are providing accurate information for each buyer to be named on the contract</p>
        <Fields>
          <Input
            label="First Name*"
            id="buyerFourFirstName"
            placeholder=""
            required={showNumberBuyerSection < 4 ? false : true}
          />
          <Input
            label="Last Name*"
            id="buyerFourLastName"
            placeholder=""
            required={showNumberBuyerSection < 4 ? false : true}
          />
          <Input
            label="Email*"
            id="buyerFourEmail"
            placeholder=""
            required={showNumberBuyerSection < 4 ? false : true}
          />
          <Input
            label="Phone*"
            id="buyerFourPhone"
            placeholder="e.g. 555-555-5555 or +555 5555 5555"
            required={showNumberBuyerSection < 4 ? false : true}
          />
          <div className="singleRow">
            <Checkbox
              label="I confirm this email belongs to buyer four. I understand that this email address cannot represent more than one buyer on the contract.*"
              id="buyerFourConsent"
              key="Buyer Four - Consent Required"
              required={showNumberBuyerSection < 4 ? false : true}
            />
          </div>
        </Fields>
      </FormSection>

      <FormSection>
        <h3>HOME OPTION ONE</h3>
        <Fields>
          <SelectList
            label="Number Of Beds*"
            options={homeOptions}
            id="homeOptionOneBeds"
            onChange={handleChangeHomeOptionOneBeds}
            required
          />
          <SelectPlan
            label="Floorplan*"
            floorplans={homeOptionFloorplans1}
            id="homeOptionOnePlan"
            onChange={handleChangeHomeOptionOnePlan}
            disabled={homeOptionOneDisable[1]}
            required
          />
          <SelectView
            label="View*"
            floorplans={homeOptionFloorplans1}
            id="homeOptionOneView"
            selectedPlan={document.getElementById('homeOptionOnePlan')?.value}
            onChange={handleChangeHomeOptionOneView}
            disabled={homeOptionOneDisable[2]}
            required
          />
          <SelectPrice
            label="Price Range*"
            floorplans={homeOptionFloorplans1}
            id="homeOptionOnePrice"
            selectedPlan={document.getElementById('homeOptionOnePlan')?.value}
            selectedView={document.getElementById('homeOptionOneView')?.value}
            disabled={homeOptionOneDisable[3]}
            required
          />
        </Fields>
      </FormSection>
      <FormSection>
        <h3>HOME OPTION TWO</h3>
        <Fields>
          <SelectList
            label="Number Of Beds"
            options={homeOptions}
            id="homeOptionTwoBeds"
            onChange={handleChangeHomeOptionTwoBeds}

          />
          <SelectPlan
            label="Floorplan"
            floorplans={homeOptionFloorplans2}
            id="homeOptionTwoPlan"
            onChange={handleChangeHomeOptionTwoPlan}
            disabled={homeOptionTwoDisable[1]}

          />
          <SelectView
            label="View"
            floorplans={homeOptionFloorplans2}
            id="homeOptionTwoView"
            selectedPlan={document.getElementById('homeOptionTwoPlan')?.value}
            onChange={handleChangeHomeOptionTwoView}
            disabled={homeOptionTwoDisable[2]}

          />
          <SelectPrice
            label="Price Range"
            floorplans={homeOptionFloorplans2}
            id="homeOptionTwoPrice"
            selectedPlan={document.getElementById('homeOptionTwoPlan')?.value}
            selectedView={document.getElementById('homeOptionTwoView')?.value}
            disabled={homeOptionTwoDisable[3]}

          />
        </Fields>
      </FormSection>
      <FormSection>
        <h3>HOME OPTION THREE</h3>
        <Fields>
          <SelectList
            label="Number Of Beds"
            options={homeOptions}
            id="homeOptionThreeBed"
            onChange={handleChangeHomeOptionThreeBeds}

          />
          <SelectPlan
            label="Floorplan"
            floorplans={homeOptionFloorplans3}
            id="homeOptionThreePlan"
            onChange={handleChangeHomeOptionThreePlan}
            disabled={homeOptionThreeDisable[1]}

          />
          <SelectView
            label="View"
            floorplans={homeOptionFloorplans3}
            id="homeOptionThreeView"
            selectedPlan={document.getElementById('homeOptionThreePlan')?.value}
            onChange={handleChangeHomeOptionThreeView}
            disabled={homeOptionThreeDisable[2]}

          />
          <SelectPrice
            label="Price Range"
            floorplans={homeOptionFloorplans3}
            id="homeOptionThreePrice"
            selectedPlan={document.getElementById('homeOptionThreePlan')?.value}
            selectedView={document.getElementById('homeOptionThreeView')?.value}
            disabled={homeOptionThreeDisable[3]}

          />
        </Fields>
      </FormSection> */}
      <FormSection>
        <h3>CONTRACT PREPARATION DOCUMENTS</h3>
        <p>To better qualify your interest and expedite your contract, we encourage you to complete the Contract Preparation section of this Home Selection Form.</p>
        <p>Please upload one of the following to confirm your Residency Status:</p>
        <ul>
          <li>Passport</li>
          <li>Permanent Resident (PR) Card</li>
          <li>Birth Certificate</li>
          <li>Citizenship Card (front and back)</li>
        </ul>
        <p>The image must be high quality, unobstructed and uncropped.</p>
        <br />
        <br />
        <Fields>
          <Input
            label="Buyer Information"
            id="residencyStatusPhotoId"
            type="file"
            accept="image/jpeg,image/png"

          />
          <div>
            <label>Passport photo guidelines</label>
            <p>Passport should be open to ID page, with both pages visible.</p>
            <img src={require('src/assets/images/document-guidelines@2x.png')} className="doc-guide" />
            <br />
            <br />
          </div>

          <Input
            label="Social Insurance Number"
            id="buyerSIN"
            placeholder="e.g. 123 456 789"
          />
          <Input
            label="Job Title / Occupation"
            id="buyerJobTitle"
          />
          <Input
            label="Employer"
            id="buyerEmployer"
          />
          <Select
            label="Are you a resident in Canada for the purposes of the Income Tax Act?"
            question={questionSelections.isPermanentResident}


          />
          <Select
            label="Are you a foreign entity for the purposes of the Property Transfer Tax in Canada/BC?"
            question={questionSelections.isForeignEntity}

          />
          <div className="singleRow">
            <p>
              <a href="https://theamazingbrentwood.com/privacy/" target="_blank">Click here</a> to view SHAPE’s Privacy Policy which governs the collection, use and disclosure of your personal information.
            </p>
          </div>
        </Fields>

      </FormSection>
      <FormSection>
      <Checkbox
        label="I CONSENT TO RECEIVING VIP EARLY ACCESS FOR COMMUNITIES MARKETED BY SHAPE MARKETING CORP. and to receiving electronic communications from Shape Marketing Corp. with respect to such communities. I may withdraw my consent at anytime by email to info@shape.ca or by post to 3100 - 1090 Pender Street W., Box 315, Vancouver, BC, Canada V6E 0E3.*"
        id="communicationConsent"
        key="Consent Required"
        required
      />
      <Checkbox
        label="BY SUBMITTING THIS FORM, I CONFIRM THAT I CONSENT TO RECEIVING A COPY OF THE DISCLOSURE STATEMENT (once filed) and any subsequent amendments thereto, relating to the development known as The Amazing Brentwood and any units forming a part thereof by electronic means from the vendor, which consent is required by the vendor pursuant to Section 15(3) of the Real Estate Development Marketing Act (British Columbia).*"
        id="disclosureConsent"
        key="Consent Required"
        required
      />
      <Checkbox
        label="I AM AUTHORIZED TO DISCLOSE ALL PERSONAL INFORMATION CONTAINED IN THIS FORM AND I CONSENT TO SHAPE MARKETING CORP. AND ITS AFFILIATED AND ASSOCIATED COMPANIES RECEIVING, STORING, USING AND DISCLOSING ALL SUCH PERSONAL INFORMATION for the limited purpose of confirming identities, preparing a contract of purchase and sale and all ancillary documents relating to purchasing a home in Neighbourhood TWO at The Amazing Brentwood and complying with all statutory and regulatory requirements relating to the buying and selling of real estate and the payment and collection of funds relating to such transactions.*"
        id="personalInfoConsent"
        key="Consent Required"
        required
      />
      </FormSection>
      <p></p>
      <p><strong>* indicates required field.</strong></p>
      <Button
        text="Submit"
        handleClick={(e) => handleFormSubmit(e)}
      // isSubmitting={isSubmitting}
      />

      <p></p>
      <p>The information contained herein is subject to change without notice. Please see a representative from The Amazing Brentwood for more details. This is not an offering for sale. E.&O.E.</p>

      {/* <Form email={email} formType="PC" /> */}



    </Root>
  );
};

const Root = styled.form`

  ${vw('padding-top', 42, 75, 122)}
  ${vw('padding-bottom', 66, 99, 105)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 300)}

  h1{
    font-family: Gotham Black;
  ${vw('font-size', 20, 50)}
  ${vw('padding-bottom', 10, 75, 20)}
  }
  h3{
    font-family: Gotham Medium;
    font-weight: 500;
    ${vw('font-size', 14, 25)}
  ${vw('padding-bottom', 30, 75, 40)}
  ${vw('padding-right', 0, 60, 200)}
  }
  p{
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-transform: none;
    ${vw('font-size', 14, 16)}
    ${vw('line-height', 22, 22)}
    ${vw('margin-bottom', 22, 20)}

  }
 span {
   color: #DE5647;
  }
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  li{
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-transform: none;
    ${vw('font-size', 14, 16)}
    ${vw('line-height', 22, 32)}
  }
  div.error label, label.error{color:red}
  div.error input, div.error select{border:solid 1px red}
  a{ color:#DE5647;}

`;
const FormSection = styled.div`
 border-top: solid 1px #000;
 /* border-bottom: solid 1px #000; */

  opacity: ${props => props.hide ? '0' : '1'};
  height: ${props => props.hide && '0'};
  pointer-events: ${props => props.hide && 'none'};

  ${
    props => !props.hide && `
      ${vw('padding-top', 22, 40)}
      ${vw('padding-bottom', 22, 0)}
    `
  }
label{font-family: Gotham Book;}
`
const Fields = styled.div`
  display: block;

  /* grid-template-areas:
  "isWorkingWithRealtor isWorkingWithRealtorEmail"
      "buyInfoFile"; */

 .singleRow{
   grid-column: 1/span 2;
    label{margin:0;
      ${vw('margin-bottom', 22, 40)}}
  }
.doc-guide{ width:100%;}
  input, select{
    display: block;
    ${vw('margin-bottom', 22, 40)}
    background-color: #FFF;
  };

  label {
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-align: left;
    ${vw('font-size', 14, 12)}
    ${vw('line-height', 17, 19)}
    ${vw('letter-spacing', 0.06)}
    ${vw('margin-bottom', 5, 3)}
  }

  @media ${media.tablet} {
    display: grid;
    grid-template-columns:1fr 1fr ;
    grid-template-rows: auto;
    grid-column-gap: 2rem;
  }
  @media ${media.desktop} {
    display: grid;
    grid-template-columns:1fr 1fr ;
    grid-template-rows: auto;
    grid-column-gap: 2rem;
  }
`;
const RealtorQuestionWrSapper = styled.div`

`;
const Logo = styled.img`
  position:relative;
  ${vw('top', -350, 0, 0)}
  ${vw('left', 0, 0, 0)}
  ${vw('width', 80, 126)}
  ${vw('height', 0, 221)}
  @media ${media.desktop} {
    position:absolute;
    left:unset;
    ${vw('right', 25, 0, 100)}
  }
`

const Loading = styled.div`
display: ${props => props.active ? 'block' : 'none'};;
  position: fixed;
  top:0;
  left:0;
  z-index: 999;
  width:100vw;
  height:100vh;
  background-color: #FFF;
  background-image: url(${require('src/assets/images/loading.gif')});
  background-repeat: no-repeat;
  background-position: center center;
  opacity: .8;

`;


export default HomeSelectionForm;
